// @flow
import * as React from 'react'
import gql from 'graphql-tag'
import { Query } from 'react-apollo'
import { type ApolloResults } from 'gql/common'
import { type Registration, REGISTRATION_FIELDS_FRAGMENT } from './registration'

type Data = {
  gatheringRegistrations: Registration[],
}

type Props = {
  children: (ApolloResults<Data>) => React.Node,
  variables: {
    gatheringId: number,
  },
}

export const GET_REGISTRATION = gql`
  query gatheringRegistrations($gatheringId: Int!) {
    gatheringRegistrations(gatheringId: $gatheringId) {
      ...RegistrationFields
    }
  }

  ${REGISTRATION_FIELDS_FRAGMENT}
`

export function RegistrationQuery(props: Props) {
  return <Query {...props} query={GET_REGISTRATION} />
}
